import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Offcanvas, Nav, Accordion } from 'react-bootstrap'
import useAuth from '../../context/auth/useAuth'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getCandidate, updateAvailability, getCandidateProfileStatus } from '../../actions/candidatesActions'
import CandidateCalendar from '../calendars/CandidateCalendar'
import { getScheduledInterviewsQuantityByCandidate } from '../../actions/choosesActions'

export const HeaderCandidate = () => {
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()
    const location = useLocation()

    const activeTitlesPaths = [
		'/candidate/profile/officialtitles',
		'/candidate/profile/courses'
	]
	const isActiveTitles = activeTitlesPaths.includes(location.pathname)

	const activeSkillsPaths = [
		'/candidate/profile/competences',
		'/candidate/profile/languages',
		'/candidate/profile/technologies',
		'/candidate/profile/methodologies'
	]
	const isActiveSkills = activeSkillsPaths.includes(location.pathname)

    const [show, setShow] = useState(false)
	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)

    const {candidate, candidateuser, candidateStatus, resultcandidate} = useSelector(state=>state.candidates)
    const {scheduleQty} = useSelector(state => state.chooses)

    const [searching, setSearching] = useState(false)
    const [showCalendar, setShowCalendar] = useState(false)

    useEffect(() => {
        if(client){
            dispatch(getCandidate(client?.id))
            dispatch(getCandidateProfileStatus(client?.id))
            dispatch(getScheduledInterviewsQuantityByCandidate(client.id))
        }
    },[dispatch, t, client])

    useEffect(() => {
        if(candidate){
            setSearching(candidate?.searching)
        }
    },[candidate])

    const handleAvailability = async(e) => {
        e.preventDefault()

        setSearching(e.target.checked)
        dispatch(updateAvailability(e.target.checked, candidate?._id))
    }

	// eslint-disable-next-line
    const [imageAux, setImage] = useState(null)

    useEffect(() => {
        if(candidate){
            setImage(candidateuser.image)
        }
    },[candidate, candidateuser])

    useEffect(() => {
        if (location.pathname === '/candidate/profile' || activeTitlesPaths.includes(location.pathname) || location.pathname === '/candidate/profile/careerpath' || activeSkillsPaths.includes(location.pathname) || location.pathname === '/candidate/actual') {
            setActiveKey('0')
        } else {
            setActiveKey(null)
        }
    // eslint-disable-next-line
    }, [location])

    const [activeKey, setActiveKey] = useState(null)

    const handleToggle = (eventKey) => {
		setActiveKey(activeKey === eventKey ? null : eventKey)
	}

    useEffect(() => {
        if(resultcandidate){
            switch (resultcandidate) {
                case 'successupdateavailability':
                    //dispatch(getCandidate(client?.id))
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultcandidate])

    return (
        <header>
            <Container>
                <Row className='my-1 d-flex justify-content-between'>
                    <Col className='d-flex align-items-center'>
                        <Link to="/candidate/dashboard">
                            <img src='/images/logotipo.svg' alt="Logotipo Skill Connected" />
                        </Link>
                    </Col>
                    <Col className='d-flex justify-content-end align-items-center'>
                        <Form.Check
                            className="me-1 p-0"
                            type="switch"
                            name="switch"
                            id="switch"
                            onChange={handleAvailability}
                            checked={searching}
                        />
                        <Form.Label htmlFor='switch' className='m-0 me-5 d-none d-sm-block'>{t('dashboard.candidate.availability')}</Form.Label>

                        <a className='ms-3 cursor alert-container' onClick={() => setShowCalendar(true)}>
                            <img src="/images/menus/calendar.svg" alt="Icono Calendario" />
                            {scheduleQty > 0 && <span className='alert-badge'></span>}
                        </a>
                        <div  className='d-block d-lg-none ms-3'>
                            <i className='fa fa-bars cursor color-primary' onClick={handleShow}></i>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Offcanvas show={show} onHide={handleClose}>
				<Offcanvas.Header closeButton>
					<Offcanvas.Title>
						<Link to="/candidate/dashboard" onClick={handleClose}>
							<img src='/images/logotipo.svg' alt="Logotipo Skill Connected" />
						</Link>
					</Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body className='menu-lateral'>
				    <Nav className="flex-column">
						<Nav.Item>
							<Link to="/candidate/dashboard" className='nav-link' onClick={handleClose}>
								<img src="/images/menus/home.svg" alt="Icono Mi Perfil" className='me-3'/>
								{t('menus.home')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Accordion defaultActiveKey="0">
								<Accordion.Item eventKey="0">
									<Accordion.Header onClick={() => handleToggle("0")}>
										<img src="/images/menus/user.svg" alt="Icono Mi Perfil" className='me-3'/>
										{t('menus.profile')}
									</Accordion.Header>
									<Accordion.Body>
										<Nav defaultActiveKey="/home" className="flex-column">
											<Nav.Item>
												<Link 
													to="/candidate/profile"
                                                    onClick={handleClose}
													className={`nav-link ${location.pathname === '/candidate/profile' ? 'active' : ''}`}
												>
													<img src="/images/menus/user.svg" alt="Icono Mi Perfil" className='me-3' />
													{t('menus.myprofile')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link 
													to="/candidate/profile/officialtitles"
                                                    onClick={handleClose}
													className={`nav-link ${isActiveTitles ? 'active' : ''} ${candidateStatus === 'completed' || parseFloat(candidateStatus) > 1 ? '' : 'disabled'}`}
												>
													<img src="/images/menus/titulos.svg" alt="Icono Titulos Academicos" className='me-3' />
													{t('menus.academic')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link 
													to="/candidate/profile/careerpath" 
													className={`nav-link ${location.pathname === '/candidate/profile/careerpath' ? 'active' : ''} ${candidateStatus === 'completed' || parseFloat(candidateStatus) > 2 ? '' : 'disabled'}`}
												>
													<img src="/images/menus/experiencia.svg" alt="Icono Experiencia Laboral" className='me-3' />
													{t('menus.professional')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link 
													to="/candidate/profile/competences"
                                                    onClick={handleClose}
													className={`nav-link ${isActiveSkills ? 'active' : ''} ${candidateStatus === 'completed' || parseFloat(candidateStatus) > 3 ? '' : 'disabled'}`}
												>
													<img src="/images/menus/habilidades.svg" alt="Icono Habilidades" className='me-3' />
													{t('menus.skills')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link
													to="/candidate/profile/ideal-position"
                                                    onClick={handleClose}
													className={`nav-link ${location.pathname === '/candidate/profile/ideal-position' ? 'active' : ''} ${candidateStatus === 'completed' ? '' : 'disabled'}`}
												>
													<img src="/images/menus/idealPosition.svg" alt="Icono puesto ideal" className='me-3' />
													{t('menus.idealPosition')}
												</Link>
											</Nav.Item>
											{/* <Nav.Item>
												<Link
													to="/candidate/actual"
													className={`nav-link ${location.pathname === '/candidate/actual' ? 'active' : ''}`}
												>
													<img src="/images/menus/puestoactual.svg" alt="Icono Puesto Actual" className='me-3' />
													{t('menus.actual')}
												</Link>
											</Nav.Item> */}
										</Nav>
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						</Nav.Item>
						<Nav.Item>
							<Link to="/candidate/active-processes" className='nav-link' onClick={handleClose}>
								<img src="/images/menus/processes.svg" alt="Procesos" className='me-3'/>
								{t('menus.candidateProcesses')}
							</Link>
						</Nav.Item>
						{/* <Nav.Item>
							<Link to="/candidate/job-portal" className='nav-link' onClick={handleClose}>
								<img src="/images/menus/portalempleo.svg" alt="Portal de empleo" className='me-3'/>
								{t('menus.jobPortal')}
							</Link>
						</Nav.Item> */}
						<Nav.Item>
							<Link to="/candidate/tickets" className='nav-link' onClick={handleClose}>
								<img src="/images/menus/ticket.svg" alt="Tickets" className='me-3'/>
								{t('menus.tickets')}
							</Link>
						</Nav.Item>
						<Nav.Item></Nav.Item>
					</Nav>
				</Offcanvas.Body>
			</Offcanvas>
            <CandidateCalendar visible={showCalendar} setVisible={setShowCalendar}/>
        </header>
    )
}
